module.exports = __webpack_public_path__ + "static/media/points-blend.ceffd3f1.svg";